export const bookWithMePageBannerTitle = "iv4rX";
export const bookWithMePageBannerSummary = "yYP4vd";
export const bookWithMeCreateANewMeeting = "xZVYQc";
export const bookWithMeDisableBookingPage = "DFjyYd";
export const bookWithMeDisableBookingPageHover = "HEy0ub";
export const bookWithMePageNotPublished = "pZ_lwe";
export const bookWithMeDashboardTitle = "HpQ3Ae";
export const bookWithMeDashboardSubtitle = "pbGRSb";
export const bookWithMePublishButtonText = "Txzq0d";
export const bookwithmeMoreOptionsAriaLabel = "JPN5vb";
export const bookwithmeEditBannerImage = "Wfg6Nb";
export const bookwithmeProfilePhotoAriaLabel = "Vs_Qdd";
export default {bookWithMePageBannerTitle,bookWithMePageBannerSummary,bookWithMeCreateANewMeeting,bookWithMeDisableBookingPage,bookWithMeDisableBookingPageHover,bookWithMePageNotPublished,bookWithMeDashboardTitle,bookWithMeDashboardSubtitle,bookWithMePublishButtonText,bookwithmeMoreOptionsAriaLabel,bookwithmeEditBannerImage,bookwithmeProfilePhotoAriaLabel};